import { createSlice, PayloadAction } from '@reduxjs/toolkit'; 

// ---------------
 
interface ReferralsAccessState {
  referrals: any[],
  selectedReferral: any, 
  isRefreshReferralsList: boolean, 
  initialRendering: boolean, 
}

// ---------------

const initialState: ReferralsAccessState = {
    referrals: [], 
    selectedReferral: null, 
    isRefreshReferralsList: false, 
    initialRendering: true, 
};

// ---------------


export const referralsAccessSlice = createSlice({

  name: 'referralsAccess',

  initialState,

  reducers: {

    setReferrals: (state, action: PayloadAction<any>) => { 

        state.referrals = action.payload; 

    },
    setSelectedReferral: (state, action: PayloadAction<any>) => { 

      state.selectedReferral = action.payload; 

    },
    setIsRefreshReferralsList: (state, action: PayloadAction<boolean>) => { 

      state.isRefreshReferralsList = action.payload; 

    },
    setInitialRendering: (state, action: PayloadAction<boolean>) => {
  
      state.initialRendering = action.payload; 

    }, 
    resetReferralsAccess: (state) => { 
        
      state.referrals = []; 
      state.selectedReferral = null;
      state.isRefreshReferralsList = false;
      state.initialRendering = true; 
    } 

  },

}); 

// ---------------

export const { 
  setReferrals, 
  setSelectedReferral, 
  setIsRefreshReferralsList, 
  setInitialRendering, 
  resetReferralsAccess } = referralsAccessSlice.actions;

export default referralsAccessSlice.reducer;